import endpoints from '../config/endpoints';

export default async function register(args) {
 return fetch(endpoints.REGISTER, {
   method: 'POST',
   headers: {
     'Content-Type': 'application/json'
   },
   body: JSON.stringify(args)
 })
   .then(data => data.json())
   .catch(error => error)
}